<div title="Select an agency to view the data under it" class="list-container" [style.width]="selectWidth">
    <select name="agencyList" [(ngModel)]="selectedAgency" (ngModelChange)="onSelectAgency()">
        <ng-container *ngIf="agencyType==='integrator'">
            <option *ngFor="let agency of agencyList" [ngValue]="agency">
                {{'Client: ' + agency.name}}
            </option>
        </ng-container>
        <ng-container *ngIf="agencyType!=='integrator'">
            <option *ngFor="let agency of agencyList" [ngValue]="agency">
                {{agency.id === customerId ? agency.name : 'Child: ' + agency.name}}
            </option>
        </ng-container>
    </select>
</div>